import React, { useId } from 'react';
import PropTypes from 'prop-types';
import MenuList from './menu-list';
import { MenuNav, Title } from './styles';

const SubpageMenu = ({ title, items, currentPath }) => {
  const titleId = useId();
  if (!items || items.length === 0) return null;

  return (
    <MenuNav aria-labelledby={titleId}>
      <Title id={titleId}>{title}</Title>
      <MenuList items={items} currentPath={currentPath} />
    </MenuNav>
  );
};

SubpageMenu.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  currentPath: PropTypes.string,
};

export default SubpageMenu;
